import {
  GET_HOLIDAYS,
  GET_HOLIDAYS_SUCCESS,
  GET_HOLIDAYS_FAIL,
  ADD_HOLIDAY,
  ADD_HOLIDAY_SUCCESS,
  ADD_HOLIDAY_FAIL,
  UPDATE_HOLIDAY,
  UPDATE_HOLIDAY_SUCCESS,
  UPDATE_HOLIDAY_FAIL,
  DELETE_HOLIDAY,
  DELETE_HOLIDAY_SUCCESS,
  DELETE_HOLIDAY_FAIL,
  SET_HOLIDAY_FIELD_ERRORS,
} from './actionTypes'

const initialState = {
  holidays: [],
  loading: false,
  error: null,
  fieldErrors: {},
}

const holidayReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_HOLIDAYS:
      return { ...state, loading: true }
    case GET_HOLIDAYS_SUCCESS:
      return { ...state, loading: false, holidays: action.payload }
    case GET_HOLIDAYS_FAIL:
      return { ...state, loading: false, error: action.payload }

    case ADD_HOLIDAY:
      return { ...state, loading: true }
    case ADD_HOLIDAY_SUCCESS:
      return { ...state, loading: false, fieldErrors: {} }
    case ADD_HOLIDAY_FAIL:
      return { ...state, loading: false, error: action.payload }

    case UPDATE_HOLIDAY:
      return { ...state, loading: true }
    case UPDATE_HOLIDAY_SUCCESS:
      return { ...state, loading: false, fieldErrors: {} }
    case UPDATE_HOLIDAY_FAIL:
      return { ...state, loading: false, error: action.payload }

    case DELETE_HOLIDAY:
      return { ...state, loading: true }
    case DELETE_HOLIDAY_SUCCESS:
      return { ...state, loading: false }
    case DELETE_HOLIDAY_FAIL:
      return { ...state, loading: false, error: action.payload }

    case SET_HOLIDAY_FIELD_ERRORS:
      return { ...state, fieldErrors: action.payload }

    default:
      return state
  }
}

export default holidayReducer
